import { ruleRunner } from 'validations/ruleRunner';
import { required, minLength, maxLength, arrayMinLength, arrayMaxLength, minimun } from 'validations/rules';

const Validations = [
  ruleRunner('type', 'tipo', minimun(1)),
  ruleRunner('title', 'título', required, maxLength(255)),
  ruleRunner('description', 'descrição', required, minLength(100), maxLength(4000)),
  ruleRunner('image_id', 'imagem', required),
  ruleRunner('categories', 'categorias', arrayMinLength(1), arrayMaxLength(5)),
];

export default Validations;
